import Button from "pages/_components/Button";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import * as i18n from "util/i18n";
import Notification from "pages/_components/Notification";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import { TransactionCard, TransactionHeader } from "pages/_components/TransactionCard";
import { bool } from "prop-types";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { actions as creditBillActions } from "reducers/creditBills";
import { useTransaction } from "../hooks/useTransactions";
import { ActionFCEMSummaryBody } from "./components/SummaryBody";

const ActionFCEMTransactionPage = ({ isDesktop }) => {
    const {
        isLoading,
        transaction,
        dispatch,
        handleSignTransaction,
        showSignButton,
        push,
        id,
        status,
        actionI18n,
    } = useTransaction(creditBillActions.setActionData, creditBillActions.cleanServiceTicket);

    const { isFlowComplete, isFinished, isBackoffice } = status;
    const { componentRef, handlePrint, mobileRef, handleShareMobile } = useReactPrint(
        `creditBill.${actionI18n}`,
        id,
        "actionFCEMTransactionPage",
    );
    const [showMoreData, setShowMoreData] = useState(!isDesktop);
    const backLinkTo = isFlowComplete ? "/creditBills" : "";

    const handleDownload = async () => {
        await setShowMoreData(true);
        return handlePrint();
    };

    return (
        <>
            <Notification scopeToShow="actionFCEMTransactionPage" />
            {!isBackoffice && (
                <ResponsiveHeader ticket metaTitle={`creditBill.${actionI18n}`} backLinkTo={backLinkTo} />
            )}
            <MainContainer showLoader={isLoading} className="credit-bills">
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader title={`creditBill.${actionI18n}`} isDesktop={isDesktop} />

                            <div className="ticket">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />
                                    <ActionFCEMSummaryBody
                                        isTicket
                                        isDesktop={isDesktop}
                                        isFinished={isFinished}
                                        setShowMoreData={setShowMoreData}
                                        showMoreData={showMoreData}
                                    />
                                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                    {!isBackoffice && (
                        <Row className="form-actions no-print">
                            {isFinished ? (
                                <>
                                    <Col xs={12} md={4} mdOffset={2}>
                                        <Button
                                            onClick={() => dispatch(push("/desktop"))}
                                            label="forms.transaction.ticket.actions.backToHome"
                                            className=" btn-outline"
                                        />
                                    </Col>
                                    <Col xs={12} md={4}>
                                        <Button
                                            onClick={handleDownload}
                                            image="images/figma/icon/download.svg"
                                            label="global.download"
                                            className="btn-primary"
                                        />
                                    </Col>
                                    {!isDesktop && (
                                        <Col xs={12} md={4}>
                                            <Button
                                                className="btn btn-outline"
                                                image="images/figma/icon/share.svg"
                                                label="global.share"
                                                onClick={() => {
                                                    handleShareMobile();
                                                }}
                                            />
                                        </Col>
                                    )}
                                </>
                            ) : (
                                <>
                                    <Col xs={12} md={4} mdOffset={showSignButton ? 2 : 4}>
                                        <Button
                                            onClick={() => dispatch(push("/creditBills"))}
                                            label="forms.transaction.ticket.actions.backToHome"
                                            className="btn btn-outline"
                                        />
                                    </Col>
                                    {showSignButton && (
                                        <Col xs={12} md={4}>
                                            <Button
                                                onClick={handleSignTransaction}
                                                label="forms.signTransaction.link"
                                                className="btn btn-primary"
                                            />
                                        </Col>
                                    )}
                                </>
                            )}
                        </Row>
                    )}
                </div>
            </MainContainer>
        </>
    );
};

ActionFCEMTransactionPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default ActionFCEMTransactionPage;
